// App.js
import React from 'react';
import AppRoutes from './routes/AppRoutes';
import './App.css';
import '../src/assets/styles/styles.css';

function App() {
  return (
    <div className="layoutContainer">
      <AppRoutes />
    </div>
  );
}

export default App;
